// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__23b3Z","title":"Section_title__39r51"};